'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidSearch = function IoAndroidSearch(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.4 23.8l8.6 8.6-2.6 2.6-8.5-8.6v-1.3l-0.5-0.5c-2 1.7-4.6 2.7-7.3 2.7-6.2 0-11.1-5-11.1-11.1s4.9-11.2 11-11.2c6.2 0 11.1 5 11.1 11.2 0 2.8-1 5.3-2.6 7.2l0.5 0.4h1.4z m-10.3 0c4.3 0 7.7-3.3 7.7-7.6s-3.4-7.8-7.7-7.8-7.7 3.5-7.7 7.8 3.4 7.6 7.7 7.6z' })
        )
    );
};

exports.default = IoAndroidSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-search.js
// module id = 1933
// module chunks = 0